export default "__VITE_ASSET__Ba5I2aTT__"